import { useEffect, useState, useCallback } from 'react';
import { supabase } from '@/lib/supabase';

export function useFreightSocket(token, user) {
  const [lastEvent, setLastEvent] = useState(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!token || !user) return;

    const orgId = user.org_id;

    // Subscribe to load changes (status updates, new loads, assignments)
    const loadsChannel = supabase
      .channel('loads-changes')
      .on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'loads',
      }, (payload) => {
        const load = payload.new || payload.old;
        if (load) {
          setLastEvent({ type: 'load_update', load });
        }
      })
      .on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'driver_latest_location',
      }, (payload) => {
        if (payload.new) {
          setLastEvent({
            type: 'location_update',
            driver_id: payload.new.driver_id,
            lat: payload.new.lat,
            lng: payload.new.lng,
            load_id: payload.new.load_id,
          });
        }
      })
      .on('postgres_changes', {
        event: 'INSERT',
        schema: 'public',
        table: 'messages',
      }, (payload) => {
        if (payload.new) {
          setLastEvent({ type: 'new_message', message: payload.new });
        }
      })
      .subscribe((status) => {
        setConnected(status === 'SUBSCRIBED');
      });

    return () => {
      supabase.removeChannel(loadsChannel);
    };
  }, [token, user]);

  return { lastEvent, connected };
}
